/**
 * 组织机构下拉选择
 * 2019-04-28 chenxiaojian
 */
import React from 'react';
import { TreeSelect } from 'antd';

import orgUtil from './orgUtil';

class OrgSelect extends React.Component {

    state = {
        orgList: [],
    }

    componentDidMount() {
        orgUtil.findOrg(
            {orgType: this.props.orgType},   //查询条件
            (res) => {
                if(res == null){
                    res = [];
                }
                this.setState({ orgList: res});
            }
        );

        if(this.props.onRef){
            this.props.onRef(this)
        }
    }

    onChange = (value, label, extra) => {
        this.props.onChange(value, label, extra);
    }

    render() {
        if(this.props.lessOneHide === true && this.state.orgList.length <2){
            return "";
        }
        let onChange = this.props.onChange ? this.onChange : null;
        return <TreeSelect treeData={this.state.orgList} {...this.props} onChange={onChange} />
    };
}

export default OrgSelect;